export default "__VITE_ASSET__lCRnSrG$__"